import { Component, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'cmp-tipo-frete',
  templateUrl: './tipo-frete.component.html',
  styleUrls: ['./tipo-frete.component.scss']
})
export class TipoFreteComponent {

  tipos: any[] = [];
  @Input() valor: any;
  @Output() selected: EventEmitter<any> = new EventEmitter;

  constructor() { 
  }

  ngOnInit(): void {
      this.listar();
  }

  listar(): void {
    this.tipos = [
        {name: 'A Combinar', value: '1', description: 'A Combinar'},
        {name: 'Vendedor', value: '2', description: 'Vendedor'},
        {name: 'Comprador', value: '3', description: 'Comprador'}
    ];
  }

  onSelected($event: any){
    this.selected.emit($event.detail.value);
  }

  setTipo(tipo: any){
    this.tipos.forEach((item) =>{
      if(tipo == item.value)
        this.valor = item.value;
    });
  }
}
